<!-- 头部进度条 -->
<template>
  <div class="selftmreg_steps">
    <div class="pointsRule">
      <ul id="list" ref="uls">
        <li>
          <a class="active">
            <span>填写基本信息</span>
            <i></i>
          </a>
        </li>
        <li>
          <a>
            <em class="before"></em>
            <span>填写申请人信息</span>
            <i></i>
          </a>
        </li>
        <li>
          <a>
            <em class="before"></em>
            <span>确认订单</span>
            <i></i>
          </a>
        </li>
        <li>
          <a>
            <em class="before"></em>
            <span>支付订单</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.selftmreg_steps {
  width: 100%;
  padding: 0px 20px;
  box-sizing: border-box;
  overflow: hidden;

  .pointsRule {
    width: 100%;
    display: inline-block;
    font-size: 16px;
    margin: 20px 0px;
    text-align: center;

    ul {
      width: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
      display: inline-block;
      width: 100%;

      li {
        width: 24%;
        display: list-item;
        text-align: center;
        float: left;
        margin-right: 10px;
        background: #e3e3e3;
        border-top: 1px solid #e3e3e3;
        height: 31px;
        position: relative;

        a {
          display: block;
          padding: 8px 0;
          cursor: pointer;
          height: 31px;
          box-sizing: border-box;

          > span {
            vertical-align: middle;
            height: 24px;
            line-height: 15px;
            display: inline-block;
            overflow: hidden;
            text-align: center;
            width: 75%;
            padding-left: 24px;
          }

          i {
            float: right;
            border: #e3e3e3 solid;
            border-width: 1px 1px 0 0;
            width: 21px;
            height: 22px;

            /* 往左上的位移变化 */

            // margin: -4px -11px 0px 10px;
            margin: 2px 0px 0px 14px;
            top: 2px;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            background: #e3e3e3;

            -moz-transform: rotate(45deg);

            /* Firefox浏览器 */
            -ms-transform: rotate(45deg);

            position: absolute;
            z-index: 22;
          }

          em.before {
            border: #e3e3e3 solid;
            border-width: 1px 1px 0 0;
            width: 21px;
            height: 22px;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            float: left;
            margin: -4px 10px 0px -11px;
            top: 2px;
            background: #fff;
            z-index: 2;
          }
        }
      }

      li:first-child {
        border-left: 1px solid #e3e3e3;
        background: #e3e3e3;

        i {
          margin: 2px 0px 0px 25px;
          background: #00AB39;
        }
      }
    }
  }
}

/* 激活后，高亮背景 优先级最高*/
.active {
  background: #00AB39 !important;
  color: #fff;
}
</style>
